module.exports = __webpack_public_path__ + "img/ci.40ef5af0.jpeg";